export class CustomRegExp extends RegExp {
    constructor(pattern: string, flags: string){
        super(pattern,flags);
    }
    [Symbol.match](str:any): RegExpMatchArray | null {
      const result = RegExp.prototype[Symbol.match].call(this, str);
      if (result) {
        result[0] = `Matched: ${result[0]}`;
      }
        return result;
    }
  }